import React, { useState } from 'react'
import { Typography } from '@mui/material'
import toast from 'react-hot-toast'
import { UserFeedbackUpdateType } from '@playback-rewards/shared-libraries'

//constants
import { RATE_APP_MODAL_STATE as MODAL_STATE } from 'constants/index'
//components
import BottomButton from 'components/common/BottomButton'
import { MaybeLaterButton } from './MaybeLaterButton'
//services
import { saveUserFeedback } from 'services/userFeedbackService'
//types
import { RateAppContentProps } from 'types'
//utils
import { handleError } from 'utils/utils'

export const RateAppContent = ({
  hideModal,
  setModalState,
  setFeedbackId,
}: RateAppContentProps) => {
  const [rating, setRating] = useState(0)
  const [isSubmitting, setSubmitting] = useState(false)

  const emptyStar = '/images/starIconEmpty.png'
  const filledStar = '/images/starIconFilled.png'

  const handleRateAction = async () => {
    if (rating === 0) {
      return toast.error('Please choose a star rating!')
    }
    setSubmitting(true)
    try {
      const { data } = await saveUserFeedback({
        type: UserFeedbackUpdateType.StarsRate,
        rating,
      })
      if (!data.feedbackId) {
        throw new Error('Feedback ID was not returned.')
      }
      setFeedbackId(data.feedbackId)
      setModalState(rating <= 4 ? MODAL_STATE.TEXT_FEEDBACK : MODAL_STATE.RATE_IN_GOOGLE_PLAY)
    } catch (error) {
      handleError(error)
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <>
      <Typography variant="h1">Please Rate Us!</Typography>
      <div className="stars">
        {[1, 2, 3, 4, 5].map((star) => (
          <img
            key={star}
            src={star <= rating ? filledStar : emptyStar}
            alt={`${star}-star`}
            className="star"
            onClick={() => setRating(star)}
          />
        ))}
      </div>
      <BottomButton className="actionButton" handleClick={handleRateAction} disabled={isSubmitting}>
        Rate
      </BottomButton>
      <MaybeLaterButton hideModal={hideModal} />
    </>
  )
}
